import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { InlineFormInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Section.svg';

type FormValues = {
  website: string;
  linkedIn?: string;
};

export const OrgWebsiteSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      website: getApplicationDataByKey('website') || '',
      linkedIn: getApplicationDataByKey('linkedIn') || '',
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      website: data.website,
      linkedin: data.linkedIn,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      website: watch('website'),
      linkedin: watch('linkedIn'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='Where can people learn more about your organization?'
        description={
          'Having an accessible website is required to apply. LinkedIn is optional. These will be visible on your public profile.'
        }
      >
        <InlineFormInput
          label='Organization website'
          placeholder='Enter website URL'
          prefixContent='http://'
          register={() =>
            register('website', {
              required: "Enter your organization's website to continue",
            })
          }
          errors={errors.website}
        />
        <InlineFormInput
          label='Organization LinkedIn (optional)'
          placeholder='Start typing country name'
          prefixContent='http://'
          register={() => register('linkedIn')}
          errors={errors.linkedIn}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
